<template>
  <div id="ImageInput">
    <input accept="image/x-png, image/jpeg" ref="inputfile" @change="changeInput" type="file">
  </div>
</template>
<script>
export default {
  name: 'ImageInput',
  data: () => ({

  }),
  methods: {
    open() {

      this.$refs.inputfile.click();
    },
    changeInput( ev ) {
      
      const input = ev.target;
      
      if ( input.files && input.files[0] ) {
        
        const reader = new FileReader();
        
        reader.onload = ( e ) => {
          
          const imageToLoad = e.target.result;
          const img = new Image();

          img.onload = () => {

            this.$emit( "imageChange", img, input.files[0] );
          }

          img.src = imageToLoad;
        }
        reader.readAsDataURL(input.files[0]);
      }

    }
  }
}
</script>
<style lang="css" scoped>
  #ImageInput{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpers/ImageInput.vue